<template>
    <div class="bind_items_detail">
        <BTable small striped bordered :items="binds" :fields="fields">
        <template #cell(user)="{ item }">
            <position_user text-empty="Користувач не знайдений" :userId="item.user_id"></position_user>
        </template>
        </BTable>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    BTooltip,
    BTable
} from 'bootstrap-vue-next';
import Position_user from "./position_user.vue";

export default {
    name: "position_item",
    props: {
        item: {
            type: [String, Number],
            required: true,
        },
    },
    
    components : {
        Position_user,
        BTable
    },
    
    data() {
        return {
            fields: [
                { key: 'bid_id', label: 'ID', class: 'align-middle' },
                { key: 'added', label: 'Дата ставки', class: 'align-middle' },
                { key: 'user', label: 'Учасник', class: '' },
                { key: 'cur_price', label: 'Ціна', class: 'align-right' },
            ],
        };
    },
    
    computed : {
        ...mapGetters({
            'history': "reduction/getHistory",
        }),
        
        binds() {
            if (this.history?.items?.hasOwnProperty(this.item)) {
                return Object.values(this.history.items[this.item].items || {});
            }
            return [];
        },
        
    }
}
</script>



<style scoped>

</style>